const SEARCH_PAGE_PATH = 'search.html';

const buildSearchUrl = (query) => {
  const url = new URL(SEARCH_PAGE_PATH, window.location.href);

  if (query) {
    url.searchParams.set('q', query);
  } else {
    url.searchParams.delete('q');
  }

  return `${url.pathname}${url.search}`;
};

export const initSearchForms = () => {
  const forms = document.querySelectorAll('[data-search-form]');

  if (!forms.length) {
    return;
  }

  forms.forEach((form) => {
    if (form.closest('.search-page')) {
      return;
    }

    const input = form.querySelector('input[type="search"]');

    if (!input) {
      return;
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const query = input.value.trim();

      window.location.href = buildSearchUrl(query);
    });
  });
};
